import { createFileRoute } from '@tanstack/react-router';

import { VenueEditPage } from '@/components/admin/sport/venue-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { adminGetVenueFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/venues_/$id')({
    component: VenueEditRoute,
    head: ({ params }) =>
        adminHead(
            params.id === 'new' ? 'אצטדיון חדש' : 'עריכת אצטדיון',
            `/admin/sport/venues/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') return null;
        return adminGetVenueFn({ data: { id: params.id } });
    },
});

function VenueEditRoute() {
    const venue = Route.useLoaderData();
    const key = useAdminEditPageKey(
        venue ? `${venue.id}:${String(venue.updatedAt)}` : undefined,
    );
    return <VenueEditPage key={key} venue={venue} />;
}
